import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { RootState } from '../../models/RootState';
import { IonRow, IonCol } from '@ionic/react';
import {
  TextField,
  FormHelperText,
  FormControl,
  OutlinedInput,
  InputAdornment,
  Button,
  IconButton,
  FormGroup,
  FormControlLabel,
  Checkbox,
} from '@material-ui/core';
import { IonSpinner } from '@ionic/react';
import KeyboardBackspaceIcon from '@material-ui/icons/KeyboardBackspace';
import { NavLink, useHistory, useLocation } from 'react-router-dom';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { toast } from 'react-toastify';
import { useFormik } from 'formik';
import PhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css';
import * as Yup from 'yup';

import API from '../../api';
import webtitleImg from '../../assets/images/brand/title.png';
import HorizontalLabelPositionBelowStepper from './Steps';
import { BRAND_NAME } from '../../constants/Branding';
import './SignUpForm.scss';
import SVLS_API from '../../svls-api';
import {
  requestStart,
  requestEnd,
  loginSuccess,
  loginFailed,
} from '../../store';
import { AffiliateRole, Role } from '../../util/stringUtil';

type StoreProps = {
  bonusEnabled: boolean;
};

const SignUpFrom: React.FC<StoreProps> = (props) => {
  const { bonusEnabled } = props;
  const roleAllowed = [AffiliateRole.MA, AffiliateRole.SA];
  const [showPassword, setShowPassword] = useState(false);
  const [userErrorMsg, setUserErrorMsg] = useState<string>('');
  const [otp, setOtp] = useState<number>(null);
  const [referralCode, setReferralCode] = useState<number>();
  const [loading, setLoading] = useState<boolean>(false);
  const [agreeTerms, setAgreeTerms] = useState<boolean>(false);
  const [activeStep, setActiveStep] = React.useState(0);
  const [phone, setPhone] = useState<any>('');
  const [country, setCountry] = useState<any>('');
  const [phoneFormat, setPhoneFormat] = useState<any>('');
  const [otpTimer, setOtpTimer] = useState<number>();
  const [otpEnterFields, setOtpEnterFields] = useState<boolean>(false);
  const [otpErrorMessage, setOtpErrorMessage] = useState<string>('');
  const [phoneNumbeErrorMsg, setPhoneNumbeErrorMsg] = useState<string>('');
  const [verificationErrorMsg, setVerificationErrorMsg] = useState<string>('');
  const [signUpErrorMsg, setsignUpErrorMsg] = useState<string>('');
  const [phoneNumberExists, setPhoneNumberExists] = useState<boolean>(false);
  const steps = ['Phone Verification', 'Sign Up'];

  const { search } = useLocation();
  const refCode = new URLSearchParams(search)?.get('refCode');

  let history = useHistory();
  const formik = useFormik({
    initialValues: {
      fullname: '',
      username: '',
      password: '',
      // phoneNumber: '',
      address: '',
      referralCode: new URLSearchParams(search)?.get('refCode'),
      otp: null,
    },
    validationSchema: Yup.object({
      username: Yup.string()
        .required('Required')
        .min(4, 'The User Name field must be at least 4 characters'),
      fullname: Yup.string().required('Required'),
      password: Yup.string().required('Required'),
      referralCode: Yup.string().required('Required'),
    }),
    onSubmit: async (values) => {
      setLoading(true);
      let postBody = {
        // currencyType: 'INR',
        fullName: values.fullname.trim(),
        otp: otp,
        password: values.password,
        phoneNumber: phone,
        referralCode: values.referralCode,
        username: values.username.toLowerCase(),
      };
      setsignUpErrorMsg('');
      try {
        const response: any = await SVLS_API.post(
          '/account/v2/accounts/sub-affiliate',
          postBody,
          {}
        );

        toast.success('Signed up successfully');
        login(postBody.username, postBody.password);
      } catch (err) {
        setsignUpErrorMsg(err?.response?.data?.message);
      } finally {
        setLoading(false);
      }
    },
  });

  const login = async (username: string, password: string) => {
    requestStart();
    try {
      const loginRequest = {
        username: username,
        password: password,
      };
      const response = await SVLS_API.post('/account/v2/login', loginRequest);

      requestEnd();
      loginSuccess(response.data);

      sessionStorage.setItem('username', username);
      sessionStorage.setItem('jwt_token', response.data);

      let claim = response.data.split('.')[1];

      if (!roleAllowed.includes(JSON.parse(window.atob(claim)).role)) {
        history.push('/access_redirect');
      }

      localStorage.removeItem(`multiMarket_${username}`);

      sessionStorage.setItem('aid', JSON.parse(window.atob(claim)).aid);
      history.push('/admin');
    } catch (err) {
      toast.error(err.response.data.message);
      // redirect to login page if the login fails.
      loginFailed(err.response.data.message);
      redirectToLogin();
    } finally {
      requestEnd();
    }
  };

  const redirectToLogin = () => {
    history.push('/login');
  };

  const showPasswordClickHandler = () => {
    setShowPassword(!showPassword);
  };

  const handleOtpTimer = (time) => {
    if (time >= 0) {
      setOtpTimer(time);
      setTimeout(() => {
        handleOtpTimer(time - 1);
      }, 1000);
    } else {
      setTimeout(() => {
        setOtpTimer(undefined);
      }, 1000);
    }
  };

  const handleChange = (e) => {
    const { target } = e;
    const { value, name } = target;
    if (name === 'phone') {
      setPhone(value);
    } else if (name === 'otp') {
      setOtp(value);
    } else if (name === 'referralCode') {
      setReferralCode(value);
    }
  };

  const checkPhoneNumberExists = async (phoneNumber: string) => {
    setLoading(true);
    try {
      const response: any = await SVLS_API.get(
        `/account/v2/users/phones/${phoneNumber}/:exists`
      );
      if (response.status === 200) {
        if (response.data === true) {
          setPhoneNumbeErrorMsg('Phone number already exists');
          setPhoneNumberExists(true);
        } else {
          setPhoneNumbeErrorMsg('');
          setPhoneNumberExists(false);
        }
      }
    } catch (err) {
      setPhoneNumbeErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (phone && phone?.length - country?.dialCode.length + 1 > 10) {
      checkPhoneNumberExists(phone);
    } else {
      setPhoneNumbeErrorMsg('');
    }
  }, [phone]);

  const sendOTP = async () => {
    setPhoneNumbeErrorMsg('');
    try {
      if (country.format?.length === phoneFormat?.length) {
        const response: any = await SVLS_API.post(
          `/account/v2/otp/?mobileNumber=${phone}`
        );
        if (response.status === 204) {
          handleOtpTimer(60);
          setOtpEnterFields(true);
        }
      }
    } catch (err) {
      setPhoneNumbeErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const validateOtp = async () => {
    setVerificationErrorMsg('');
    try {
      if (country.format.length === phoneFormat.length) {
        const response: any = await SVLS_API.post(
          `/account/v2/otp/validate?mobileNumber=${phone}&otp=${otp}`,
          {}
        );
        if (response.status === 204) {
          setActiveStep(1);
          setOtpErrorMessage('');
        }
      }
    } catch (err) {
      setVerificationErrorMsg(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleNextStep = () => {
    if (phone === '') {
      toast.error('Please Enter Phone Number');
      return;
    }
    if (!otp || otp.toString().length !== 6) {
      setOtpErrorMessage('Please Enter Valid OTP');
      return;
    }
    setOtpErrorMessage('');
    setLoading(true);
    validateOtp();
  };

  const checkUserName = async (e) => {
    setsignUpErrorMsg('');
    try {
      const { target } = e;
      const { value } = target;
      if (value.length > 3) {
        const response: any = await SVLS_API.get(
          `/account/v2/users/${value}/:exists`
        );
        if (response.status === 200) {
          if (response.data) {
            setUserErrorMsg('User name already exists');
          } else {
            setUserErrorMsg('');
          }
        }
      }
    } catch (err) {
      setsignUpErrorMsg('"Something went wrong Please try again"');
      // toast.error('Something went wrong, Please try again');
    }
  };

  return (
    <div className="sign-up-ctn">
      <IonRow>
        <IonCol sizeLg="12" sizeXs="12" className="card-col">
          <div className="title-row">
            <img src={webtitleImg} alt="title" className="logo" />
          </div>
          <div className="card-bg">
            <div className="card-section">
              {activeStep === 0 ? (
                <>
                  <div className="card">
                    <div className="page-title">Sign Up</div>
                    <IonRow>
                      {' '}
                      <HorizontalLabelPositionBelowStepper
                        activeStep={activeStep}
                        steps={steps}
                      />{' '}
                    </IonRow>
                    <IonRow>
                      <IonCol sizeXs="12" sizeLg="12" className="input-col">
                        <div className="input-row">
                          <div className="label">{'Phone Number'}</div>
                          <PhoneInput
                            country={'in'}
                            placeholder={'Enter phone number'}
                            value={phone}
                            onChange={(value, country, e, formattedValue) => {
                              setPhone(value);
                              setCountry(country);
                              setPhoneFormat(formattedValue);
                            }}
                            countryCodeEditable={false}
                            disabled={otpEnterFields}
                          />
                          {phoneNumbeErrorMsg ? (
                            <FormHelperText error id="my-helper-text">
                              {phoneNumbeErrorMsg}
                            </FormHelperText>
                          ) : null}
                        </div>
                      </IonCol>
                    </IonRow>
                    {!otpEnterFields ? (
                      <>
                        <IonRow>
                          <IonCol sizeLg="12" sizeXs="12" className="input-col">
                            <FormGroup className="mt-0">
                              <FormControlLabel
                                control={
                                  <Checkbox
                                    onChange={() => setAgreeTerms(!agreeTerms)}
                                  />
                                }
                                label={`
                                ${'I agree to the all terms & Conditions of'} ${BRAND_NAME}.`}
                              />
                            </FormGroup>
                          </IonCol>
                        </IonRow>

                        <div className="btn-section">
                          <Button
                            className="btn"
                            color="primary"
                            type="submit"
                            variant="contained"
                            endIcon={
                              loading ? <IonSpinner name="lines-small" /> : ''
                            }
                            disabled={
                              !agreeTerms ||
                              phone === '' ||
                              phone?.length - country?.dialCode.length + 1 <=
                                10 ||
                              phoneNumberExists
                            }
                            onClick={() => sendOTP()}
                          >
                            Send OTP
                          </Button>
                        </div>

                        <IonRow className="msg-row">
                          <div className="msg">
                            Have an account?
                            <NavLink
                              className="sign-in-and-home-link"
                              to="/login"
                            >
                              Sign In
                            </NavLink>
                          </div>
                          <div className="msg back-home">
                            <NavLink className="sign-in-and-home-link" to="/">
                              Back to home
                            </NavLink>
                          </div>
                        </IonRow>
                      </>
                    ) : null}

                    {otpEnterFields ? (
                      <>
                        <IonRow>
                          <IonCol sizeLg="12" sizeXs="12" className="input-col">
                            <div className="input-row flex-column">
                              <div className="label">OTP *</div>
                              <TextField
                                className="number-input"
                                type="number"
                                name="otp"
                                variant="outlined"
                                placeholder={'Enter otp'}
                                error={
                                  otpErrorMessage !== ''
                                    ? true
                                    : false || verificationErrorMsg !== ''
                                    ? true
                                    : false
                                }
                                helperText={
                                  otpErrorMessage !== ''
                                    ? otpErrorMessage
                                    : null || verificationErrorMsg !== ''
                                    ? verificationErrorMsg
                                    : null
                                }
                                onKeyPress={(evt) => {
                                  if (
                                    (evt.which != 8 &&
                                      evt.which != 0 &&
                                      evt.which < 48) ||
                                    evt.which > 57
                                  ) {
                                    evt.preventDefault();
                                  }
                                }}
                                onChange={(e) => handleChange(e)}
                              />
                              <div
                                className="label link"
                                onClick={() => {
                                  if (!otpTimer) {
                                    sendOTP();
                                  }
                                }}
                              >
                                {otpTimer !== undefined &&
                                otpTimer !== null &&
                                otpTimer >= 0
                                  ? `${'Resend in'} ${otpTimer} ${'seconds'}`
                                  : 'Send OTP'}
                              </div>
                            </div>
                          </IonCol>
                        </IonRow>
                        <div className="btn-section">
                          <Button
                            className="btn"
                            color="primary"
                            type="submit"
                            variant="contained"
                            endIcon={
                              loading ? <IonSpinner name="lines-small" /> : ''
                            }
                            disabled={!agreeTerms}
                            onClick={() => handleNextStep()}
                          >
                            {'Verify OTP'}
                          </Button>
                        </div>

                        <IonRow className="msg-row">
                          <div
                            className="msg"
                            onClick={() => history.push('/')}
                          >
                            {'Have an account?'}
                            <NavLink className="sign-in-and-home-link" to="/">
                              {'Sign In'}
                            </NavLink>
                          </div>
                        </IonRow>
                      </>
                    ) : null}
                  </div>
                </>
              ) : null}
              {activeStep === 1 ? (
                <>
                  <form
                    onSubmit={formik.handleSubmit}
                    className="card"
                    autoComplete="off"
                  >
                    <div className="page-title">{'Sign Up'}</div>
                    <IonRow>
                      {' '}
                      <HorizontalLabelPositionBelowStepper
                        activeStep={activeStep}
                        steps={steps}
                      />{' '}
                    </IonRow>
                    <IonRow className="input-row">
                      <div className="form-control">
                        <div className="label">{'Username'} *</div>
                        <TextField
                          className="login-input-field user-name"
                          type="text"
                          placeholder={'Enter username'}
                          variant="outlined"
                          name="username"
                          onKeyUp={(e) => checkUserName(e)}
                          error={
                            (formik.touched.username &&
                              formik.errors.username) ||
                            userErrorMsg !== ''
                              ? true
                              : false
                          }
                          helperText={
                            formik.touched.username && formik.errors.username
                              ? formik.errors.username
                              : userErrorMsg !== ''
                              ? userErrorMsg
                              : null
                          }
                          {...formik.getFieldProps('username')}
                        />
                      </div>
                    </IonRow>

                    <IonRow className="input-row">
                      <div className="form-control">
                        <div className="label">{'Full name'} *</div>
                        <TextField
                          className="login-input-field user-name"
                          type="text"
                          name="fullname"
                          variant="outlined"
                          placeholder={'Enter Fullname'}
                          error={
                            formik.touched.fullname && formik.errors.fullname
                              ? true
                              : false
                          }
                          helperText={
                            formik.touched.fullname && formik.errors.fullname
                              ? formik.errors.fullname
                              : null
                          }
                          {...formik.getFieldProps('fullname')}
                        />
                      </div>
                    </IonRow>

                    <IonRow className="input-row">
                      <div className="form-control">
                        <div className="label">{'Password'} *</div>
                        <FormControl
                          className="login-input-field pwd-field"
                          variant="outlined"
                          error={
                            formik.touched.password && formik.errors.password
                              ? true
                              : false
                          }
                        >
                          <OutlinedInput
                            id="standard-adornment-password"
                            type={showPassword ? 'text' : 'password'}
                            name="password"
                            placeholder="Enter Password"
                            {...formik.getFieldProps('password')}
                            endAdornment={
                              <InputAdornment position="end">
                                <IconButton
                                  aria-label="toggle password visibility"
                                  onClick={showPasswordClickHandler}
                                  onMouseDown={showPasswordClickHandler}
                                >
                                  {showPassword ? (
                                    <Visibility className="no-margin" />
                                  ) : (
                                    <VisibilityOff className="no-margin" />
                                  )}
                                </IconButton>
                              </InputAdornment>
                            }
                          />
                          {formik.touched.password && formik.errors.password ? (
                            <FormHelperText error id="my-helper-text">
                              {formik.errors.password}
                            </FormHelperText>
                          ) : null}
                          {signUpErrorMsg ? (
                            <FormHelperText error id="my-helper-text">
                              {signUpErrorMsg}
                            </FormHelperText>
                          ) : null}
                        </FormControl>
                      </div>
                    </IonRow>
                    <IonRow className="input-row">
                      <div className="form-control">
                        <div className="label">{'Referral Code'}</div>
                        <TextField
                          className="login-input-field user-name"
                          type="text"
                          name="fullname"
                          variant="outlined"
                          placeholder={'Enter Referral code'}
                          disabled={!!refCode}
                          error={
                            formik.touched.referralCode &&
                            formik.errors.referralCode
                              ? true
                              : false
                          }
                          helperText={
                            formik.touched.referralCode &&
                            formik.errors.referralCode
                              ? formik.errors.referralCode
                              : null
                          }
                          {...formik.getFieldProps('referralCode')}
                        />
                      </div>
                    </IonRow>

                    <IonRow></IonRow>
                    <IonRow className="button-row">
                      <Button
                        className="signup-btn"
                        color="primary"
                        endIcon={
                          loading ? <IonSpinner name="lines-small" /> : ''
                        }
                        type="submit"
                        variant="contained"
                        disabled={!(formik.isValid && userErrorMsg === '')}
                      >
                        {'Sign Up'}
                      </Button>
                    </IonRow>
                  </form>
                </>
              ) : null}
            </div>
          </div>
        </IonCol>
      </IonRow>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  return {
    loggedIn: state.auth.loggedIn,
    bonusEnabled: state.common.domainConfig.bonus,
  };
};

export default connect(mapStateToProps)(SignUpFrom);
